import React from "react";
import "./PresenceSection.css";

const cards = [
  // {
  //   icon: "/assets/presence-country.svg",
  //   title: "Republic of Congo",
  // },
  {
    icon: "/assets/presence-portal.svg",
    title: "Sabre Red 360 Portal",
  },
  {
    icon: "/assets/presence-training.svg",
    title: "Sabre Training",
  },
  {
    icon: "/assets/presence-certificate.svg",
    title: "Certification Programs",
  },
  {
    icon: "/assets/presence-developer.svg",
    title: "SabreDeveloper Center",
  },
];

function PresenceSection() {
  return (
    <section className="presence-section section-padding">

      <div className="presence-pattern"></div>

      <div className="container">

        <div className="row align-items-center">

          {/* Left */}

          <div className="col-lg-6">

            <h2 className="heading-title presence-title">
              Our Presence in <span className="title-blue">Africa</span>
            </h2>

            <p className="desc presence-descp">
              TNS Global, in partnership with Sabre Corporation, is expanding
              its Global Distribution System (GDS) across 14 high-growth
              African countries — driving innovation, accessibility, and
              connectivity in the travel industry.
            </p>

          </div>

          {/* Right */}

          <div className="col-lg-6">

            <div className="presence-grid">

              {cards.map((item, index) => (

                <div
                  href="/"
                  key={index}
                  className="presence-card"
                >

                  <div className="presence-left">

                    <img
                      src={item.icon}
                      alt=""
                    />

                    <span>{item.title}</span>

                  </div>

                  <img
                    src="/assets/check-circle.svg"
                    alt=""
                    className="presence-check"
                  />

                </div>

              ))}

            </div>

          </div>

        </div>

      </div>

    </section>
  );
}

export default PresenceSection;